<div class="vc-clinic-selector">
  @if (loading) {
    <div class="vc-clinic-selector__state">{{ "COMMON.LOADING" | translate }}</div>
  } @else {
    <header class="vc-clinic-selector__header">
      <h2>{{ "CONTEXT.SELECT_CLINIC_TITLE" | translate }}</h2>
      <p>
        {{ "CONTEXT.SELECT_CLINIC_SUBTITLE" | translate }}
        @if (activeCustomer?.name) {
          <strong>{{ activeCustomer?.name }}</strong>
        }
      </p>
    </header>

    <div class="vc-clinic-selector__grid">
      @for (site of sites; track site.id) {
        <button
          class="vc-clinic-selector__card"
          type="button"
          [disabled]="switchingSiteId === site.id"
          (click)="selectClinic(site)"
        >
          <span class="vc-clinic-selector__name">{{ site.name }}</span>
          <span class="vc-clinic-selector__meta">{{ site.identifier }}</span>
        </button>
      }
    </div>

    @if (canOpenAdministration) {
      <button
        type="button"
        class="vc-clinic-selector__exit"
        (click)="openAdministration()"
      >
        {{ "ADMIN.WORKSPACE.TITLE" | translate }}
      </button>
    }

    @if (isActingSuperadmin) {
      <button type="button" class="vc-clinic-selector__exit" (click)="exitActingMode()">
        {{ "CONTEXT.BACK_TO_CUSTOMERS" | translate }}
      </button>
    }
  }
</div>
